var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pos-absolute pos-top pos-left w-full h-full d-flex flex-justify-center"},[_c('img',{staticClass:"h-full mx-auto d-block",staticStyle:{"object-fit":"cover"},attrs:{"src":`${_vm.$scope.CDN_IMAGES}/images/site/2021/brand-book/${_vm.src}?w=1920&auto=compress,format&q=65`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }